import React from 'react';
import PropTypes from 'prop-types';


export default function TimelineItem({children, type, recipient}) {
  return (
    <div className="timelineItem">
      {children.map((child, index) => {
        return React.cloneElement(child, {
          key: index,
          recipient: recipient,
          type: type
        })
      })}
    </div>
  );
}

TimelineItem.propTypes = {
  type: PropTypes.string.isRequired,
  recipient: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired
  })
};
